"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _lodash = require("lodash");
var _Filter = _interopRequireDefault(require("../Filter"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var defaultLocationState = {
  citiesOptions: [],
  countiesOptions: [],
  citiesPlaceholder: 'Select state(s) first',
  countiesPlaceholder: 'Select state(s) first',
  countiesResponse: [],
  citiesResponse: [],
  states: [],
  counties: [],
  cities: []
};
var ResidencyRequirementsFilter = /*#__PURE__*/function (_Component) {
  _inherits(ResidencyRequirementsFilter, _Component);
  var _super = _createSuper(ResidencyRequirementsFilter);
  function ResidencyRequirementsFilter(props) {
    var _this;
    _classCallCheck(this, ResidencyRequirementsFilter);
    _this = _super.call(this, props);
    _this.countNestedOptions = _this.countNestedOptions.bind(_assertThisInitialized(_this));
    _this.debouncedChange = (0, _lodash.debounce)(props.onFiltersChange, 400);
    _this.fetchPlaces = _this.fetchPlaces.bind(_assertThisInitialized(_this));
    _this.getActiveStatesOptions = _this.getActiveStatesOptions.bind(_assertThisInitialized(_this));
    _this.getChildren = _this.getChildren.bind(_assertThisInitialized(_this));
    _this.getPlaceholderText = _this.getPlaceholderText.bind(_assertThisInitialized(_this));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.mapPlaces = _this.mapPlaces.bind(_assertThisInitialized(_this));
    _this.setOptionsFromParent = _this.setOptionsFromParent.bind(_assertThisInitialized(_this));
    _this.countyFilter = null;
    _this.countyRenderLimit = 50;
    _this.cityFilter = null;
    _this.cityRenderLimit = 50;
    _this.state = _objectSpread(_objectSpread({}, defaultLocationState), {}, {
      statesOptions: props.states
    });
    return _this;
  }
  _createClass(ResidencyRequirementsFilter, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var oldStates = (0, _lodash.get)(this.props, 'filters.states', []);
      var newStates = (0, _lodash.get)(nextProps, 'filters.states', []);
      var parentStatesOptions = nextProps.parentStatesOptions;
      if ((0, _lodash.isEmpty)(parentStatesOptions) && !(0, _lodash.isEmpty)(oldStates) && !(0, _lodash.isEqual)(oldStates, newStates)) {
        var statesOptions = this.getActiveStatesOptions(newStates);
        this.setState({
          statesOptions: statesOptions
        });
        this.handleChange(newStates, 'states');
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      this.setOptionsFromParent(prevProps);
    }
  }, {
    key: "getChildren",
    value: function getChildren(places, selected) {
      return (0, _lodash.map)(places, function () {
        var place = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return {
          label: (0, _lodash.get)(place, 'display_name', '').concat(', ', place.state),
          value: place.full_code,
          initial: (0, _lodash.indexOf)(selected, place.full_code) >= 0
        };
      }, []);
    }
  }, {
    key: "getPlaceholderText",
    value: function getPlaceholderText(renderLimit, optionsCount) {
      return optionsCount >= renderLimit ? "Showing ".concat(renderLimit, " results - Type to narrow search") : 'Search';
    }
  }, {
    key: "getActiveStatesOptions",
    value: function getActiveStatesOptions(states) {
      return (0, _lodash.reduce)(this.state.statesOptions, function (acc, opt) {
        return [].concat(_toConsumableArray(acc), [{
          label: opt.label,
          value: opt.value,
          initial: (0, _lodash.indexOf)(states, opt.value) >= 0
        }]);
      }, []);
    }
  }, {
    key: "setOptionsFromParent",
    value: function setOptionsFromParent(prevProps) {
      var _this$props = this.props,
        filters = _this$props.filters,
        parentCitiesOptions = _this$props.parentCitiesOptions,
        parentCountiesOptions = _this$props.parentCountiesOptions,
        parentStatesOptions = _this$props.parentStatesOptions;
      if (!(0, _lodash.isEmpty)(parentStatesOptions) && !(0, _lodash.isEqual)(parentStatesOptions, prevProps.parentStatesOptions)) {
        this.setState({
          statesOptions: parentStatesOptions
        });
      }
      if (!(0, _lodash.isEmpty)(parentStatesOptions) && !(0, _lodash.isEqual)(parentCountiesOptions, prevProps.parentCountiesOptions)) {
        var countiesOptions = this.mapPlaces(parentCountiesOptions, 'counties', (0, _lodash.get)(filters, 'counties', []));
        var countiesPlaceholder = this.getPlaceholderText(this.countyRenderLimit, this.countNestedOptions(countiesOptions));
        this.setState({
          countiesOptions: countiesOptions,
          countiesPlaceholder: countiesPlaceholder
        });
      }
      if (!(0, _lodash.isEmpty)(parentStatesOptions) && !(0, _lodash.isEqual)(parentCitiesOptions, prevProps.parentCitiesOptions)) {
        var citiesOptions = this.mapPlaces(parentCitiesOptions, 'places', (0, _lodash.get)(filters, 'cities', []));
        var citiesPlaceholder = this.getPlaceholderText(this.cityRenderLimit, this.countNestedOptions(citiesOptions));
        this.setState({
          citiesOptions: citiesOptions,
          citiesPlaceholder: citiesPlaceholder
        });
      }
    }
  }, {
    key: "countNestedOptions",
    value: function countNestedOptions(nestedOptions) {
      var counterFunc = function counterFunc(memo, option) {
        return memo + (0, _lodash.get)(option, 'children.length', 0);
      };
      var total = (0, _lodash.reduce)(nestedOptions, counterFunc, 0);
      if (total > 0) {
        return total;
      }

      // If none of `nestedOptions` has children, then the length is that of `nestedOptions`.
      return nestedOptions.length;
    }
  }, {
    key: "fetchPlaces",
    value: function fetchPlaces(states) {
      var _this2 = this;
      var promises = Promise.all([this.props.fetchStatesGeography(states, 'counties'), this.props.fetchStatesGeography(states, 'places')]);
      promises.then(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          counties = _ref2[0],
          cities = _ref2[1];
        var filters = _this2.props.filters;
        var countiesOptions = _this2.mapPlaces(counties, 'counties', (0, _lodash.get)(filters, 'counties', []));
        var citiesOptions = _this2.mapPlaces(cities, 'places', (0, _lodash.get)(filters, 'cities', []));
        var countiesPlaceholder = _this2.getPlaceholderText(_this2.countyRenderLimit, _this2.countNestedOptions(countiesOptions));
        var citiesPlaceholder = _this2.getPlaceholderText(_this2.cityRenderLimit, _this2.countNestedOptions(citiesOptions));
        _this2.props.onResidencyOptionsChange(counties, cities);
        _this2.setState({
          countiesResponse: counties,
          citiesResponse: cities,
          countiesOptions: countiesOptions,
          citiesOptions: citiesOptions,
          countiesPlaceholder: countiesPlaceholder,
          citiesPlaceholder: citiesPlaceholder
        }, function () {
          _this2.countyFilter.onOptionChange({});
          _this2.cityFilter.onOptionChange({});
        });
      });
      return promises;
    }
  }, {
    key: "mapPlaces",
    value: function mapPlaces(places, placePath) {
      var _this3 = this;
      var selected = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      return (0, _lodash.map)(places, function () {
        var place = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return {
          label: place.state.display_name,
          value: place.state.abbreviation,
          children: _this3.getChildren((0, _lodash.get)(place, placePath), selected)
        };
      });
    }
  }, {
    key: "handleChange",
    value: function handleChange(filters, key) {
      var _this4 = this;
      if (key === 'states') {
        if ((0, _lodash.isEmpty)(filters)) {
          return this.setState(_objectSpread({}, defaultLocationState), function () {
            _this4.handleChange([], 'counties');
            _this4.handleChange([], 'cities');
          });
        }
        var statesOptions = this.getActiveStatesOptions(filters);
        return this.fetchPlaces(filters).then(function () {
          _this4.setState({
            states: filters,
            statesOptions: statesOptions
          }, function () {
            return _this4.debouncedChange((0, _lodash.uuPick)(_this4.state, ['states', 'counties', 'cities']));
          });
        });
      }
      if (key === 'counties') {
        if ((0, _lodash.isEmpty)(filters)) {
          this.handleChange([], 'cities');
        }
      }
      var optionsKey = "".concat(key, "Options");
      var responseKey = "".concat(key, "Response");
      var newOptions = this.mapPlaces((0, _lodash.get)(this.state, responseKey, []), key === 'counties' ? 'counties' : 'places', filters);
      return this.setState(_defineProperty(_defineProperty({}, key, filters), optionsKey, newOptions), function () {
        return _this4.debouncedChange((0, _lodash.uuPick)(_this4.state, ['states', 'counties', 'cities']));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;
      var label = this.props.label;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "ui-filter-section ui-residency-requirements"
      }, /*#__PURE__*/_react["default"].createElement("h5", {
        className: "ui-filter-section__label"
      }, label), /*#__PURE__*/_react["default"].createElement(_Filter["default"], {
        id: "ui-residency-states",
        name: "state",
        filterKey: "states",
        options: this.state.statesOptions,
        onFiltersChange: this.handleChange,
        uniqIdPrefix: "residency-states"
      }), /*#__PURE__*/_react["default"].createElement(_Filter["default"], {
        ref: function ref(c) {
          _this5.countyFilter = c;
        },
        id: "ui-residency-counties",
        name: "county",
        pluralName: "counties",
        filterKey: "counties",
        options: this.state.countiesOptions,
        onFiltersChange: this.handleChange,
        optionsRenderLimit: this.countyRenderLimit,
        searchPlaceholder: this.state.countiesPlaceholder,
        uniqIdPrefix: "residency-counties"
      }), /*#__PURE__*/_react["default"].createElement(_Filter["default"], {
        ref: function ref(c) {
          _this5.cityFilter = c;
        },
        id: "ui-residency-cities",
        name: "city",
        pluralName: "cities",
        filterKey: "cities",
        options: this.state.citiesOptions,
        onFiltersChange: this.handleChange,
        optionsRenderLimit: this.cityRenderLimit,
        searchPlaceholder: this.state.citiesPlaceholder,
        uniqIdPrefix: "residency-cities"
      }));
    }
  }]);
  return ResidencyRequirementsFilter;
}(_react.Component);
ResidencyRequirementsFilter.propTypes = {
  /** action calling the geo API */
  fetchStatesGeography: _propTypes.PropTypes.func.isRequired,
  /** current filters */
  filters: _propTypes.PropTypes.object.isRequired,
  /** Label of the filter group */
  label: _propTypes.PropTypes.string.isRequired,
  /**
   * @param {array} activeFilters array of selected filters
   * @public
  */
  onFiltersChange: _propTypes.PropTypes.func.isRequired,
  /**
    @param {array} countiesOptions array of counties for the action
    @param {array} citiesOptions array of cities for the action
  */
  onResidencyOptionsChange: _propTypes.PropTypes.func,
  /** array of US states */
  states: _propTypes.PropTypes.array.isRequired,
  /** array of states options set by the parent */
  parentStatesOptions: _propTypes.PropTypes.array,
  /** array of counties options set by the parent */
  parentCountiesOptions: _propTypes.PropTypes.array,
  /** array of cities options set by the parent */
  parentCitiesOptions: _propTypes.PropTypes.array
};
ResidencyRequirementsFilter.defaultProps = {
  onResidencyOptionsChange: _lodash.noop,
  parentCitiesOptions: [],
  parentCountiesOptions: [],
  parentStatesOptions: []
};
var _default = exports["default"] = ResidencyRequirementsFilter;